import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentsService } from '../services/payments.service';

export const PaymentResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  paymentsService: PaymentsService = inject(PaymentsService)
): Observable<any> => {
  return forkJoin([paymentsService.getPublicKey(), paymentsService.getOrderPackages()]).pipe(
    map((data: any[]) => {
      return {
        publicKey: data[0],
        packages: data[1]
      };
    })
  );
};
